import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;

  .button-nif {
    > div {
      margin-left: 0;
    }
  }

  .excerpt {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .select-address {
    display: flex;
    align-items: flex-start;
    justify-content: stretch;
    flex-direction: column;
    gap: 8px;
    cursor: pointer;

    .align {
      width: 100%;
      display: flex;
      align-items: center;
    }

    svg {
      min-width: 32px;
    }
  }
`

export const Select = styled.div`
  position: relative;

  .select {
    text-align: left;
    max-height: 200px;
    height: auto;
    width: 300px;
    overflow-y: auto;
    z-index: 14;
    position: absolute;
    top: 0px;
    bottom: auto;
    z-index: 1;
    width: 380px;
    padding: 0px 24px 0px 30px;
    align-self: center;
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(35, 44, 53, 0.1) 0px 40px 40px 0px;
  }

  li {
    margin: 0px;
    height: auto;
    font-family: Ubuntu, sans-serif;
    text-rendering: optimizelegibility;
    -webkit-font-smoothing: antialiased;
    letter-spacing: 0.2px;
    font-size: 14px;
    color: rgb(100, 100, 100);
    font-weight: 300;
    transition: color 0.1s ease-in-out 0s;
    width: auto;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 40px;
    cursor: pointer;
    transition: color 0.3s ease-in-out;

    :hover {
      color: #0093b2;
    }
  }
`
